import React from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../../components/common/InfoUnavailable';

function DrugInformation({ medicareDrugInfo, drugName }) {
  const refactoredInformation = medicareDrugInfo?.hits?.hits[0]?._source;

  const getQuantityLimitText = (info) => {
    const hasQuantityLimit = info.QUANTITY_LIMIT_YN?.toUpperCase() === 'Y';

    if (!hasQuantityLimit) {
      return 'No quantity limit';
    }

    // Extract and sanitize the amount
    const amount = info.QUANTITY_LIMIT_AMOUNT?.trim();
    if (!amount) {
      return 'Invalid quantity limit amount';
    }

    // Parse and validate days
    const days = parseInt(info.QUANTITY_LIMIT_DAYS?.trim(), 10);
    if (isNaN(days) || days <= 0) {
      return `${amount} pills (period not specified)`;
    }

    // Determine proper day label using template literal
    const dayLabel = days === 1 ? 'day' : 'days';

    return `${amount} pills per ${days} ${dayLabel}`;
  };

  return (
    <div
      className="tab-pane fade show active"
      id="pills-home1-medicare"
      role="tabpanel"
      aria-labelledby="pills-medicare-home-tab"
      tabIndex={0}
    >
      <div>
        <h1 className="drug-name">
          {drugName}
          <span className="px-2">Covered</span>
        </h1>
        {refactoredInformation ? (
          <div className="row">
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Drug Tier</label>
              <p>Tier {refactoredInformation.TIER_LEVEL_VALUE}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Step Therapy</label>
              <p>
                {refactoredInformation.STEP_THERAPY_YN === 'Y'
                  ? 'Required'
                  : 'Not Required'}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Prior Authorization</label>
              <p>
                {refactoredInformation.PRIOR_AUTHORIZATION_YN === 'Y'
                  ? 'Required'
                  : 'Not Required'}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Quantity Limit</label>
              <p>{getQuantityLimitText(refactoredInformation)}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Route</label>
              <p className="text-capitalize">
                {refactoredInformation.NDC_INFO.Route}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Dosage Form</label>
              <p className="text-capitalize">
                {refactoredInformation.NDC_INFO.DosageForm}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Strength</label>
              <p>{`${refactoredInformation.NDC_INFO.Strength} ${refactoredInformation.NDC_INFO.Unit}`}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Classification (ETC)</label>
              <p>{refactoredInformation.NDC_INFO.Classification}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Federal Legend</label>
              <p>{refactoredInformation.NDC_INFO.FederalLegendCodeDesc}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Contract Year</label>
              <p>{refactoredInformation.CONTRACT_YEAR}</p>
            </div>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
}

DrugInformation.propTypes = {
  medicareDrugInfo: PropTypes.object.isRequired,
};

export default DrugInformation;
